import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectsPage from "../pages/projects/page";
import ProjectDetailPage from "../pages/projects/detail/page";
import ProductsPage from "../pages/products/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkimizda",
    element: <AboutPage />,
  },
  {
    path: "/projeler",
    element: <ProjectsPage />,
  },
  {
    path: "/projeler/:slug",
    element: <ProjectDetailPage />,
  },
  {
    path: "/urunler",
    element: <ProductsPage />,
  },
  {
    path: "/iletisim",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;